import { modulesSelector } from '@audacy-clients/core/atoms/modules';
import type { TModuleRequest } from '@audacy-clients/core/atoms/modules/requests';
import type { IView } from '@audacy-clients/core/atoms/wrappers/modules';
import { useRecoilValue } from 'recoil';

export const useModules = (request: TModuleRequest): IView => {
  return useRecoilValue(modulesSelector(request));
};
